import { NgModule } from '@angular/core';
import { OvGenericModule } from '@ov-suite/ui';
import { InventoryContainerEvent } from '@ov-suite/models-warehouse';
import { WarehousePermission } from '../../helpers/permissions.helpers';

@NgModule({
  imports: [
    OvGenericModule.forRoot({
      entity: InventoryContainerEvent,
      api: 'warehouselink',
      createTitle: 'Inventory Container Events',
      route: ['container-events'],
      tableTitle: 'Pallets Events',
      hideAdd: true,
      hideImport: true,
      hideEditDelete: true,
      permissionId: WarehousePermission.resources,
    }),
  ],
})
export class InventoryContainerEventsModule {}
